// HTTP fallback for environments where WebSockets are blocked (corporate
// proxies etc.). Slow but functional; popSocket.ts orchestrates when to use it.

export async function postPops(n: number): Promise<number | null> {
  try {
    const res = await fetch("/api/pop", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ n }),
    });
    if (!res.ok) return null;
    const body: unknown = await res.json();
    const total = (body as { total?: unknown }).total;
    return typeof total === "number" && Number.isFinite(total) ? total : null;
  } catch {
    return null;
  }
}

export async function getCount(): Promise<{ total: number; live: number } | null> {
  try {
    const res = await fetch("/api/count");
    if (!res.ok) return null;
    const body: unknown = await res.json();
    const total = (body as { total?: unknown }).total;
    const live = (body as { live?: unknown }).live;
    if (typeof total === "number" && Number.isFinite(total)) {
      return { total, live: typeof live === "number" ? live : 0 };
    }
    return null;
  } catch {
    return null;
  }
}
